import {
  Box,
  Button,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import React, { useState } from 'react'
import { useExecutions } from './queries/executions'
import { S3Link } from '../../../shared/src/data/s3Link'
import { ScanDetails } from '../../../shared/src/data/scanDetails'
import { useNavigate } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(10),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    button: {
      margin: theme.spacing(2, 0),
      padding: theme.spacing(1, 4),
      fontSize: '16px',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    saveButton: {
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    addExecutionButton: {
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    alertContainer: {
      textAlign: 'center',
    },
    loading: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }),
)

interface AddExecutionProps {
  scan: ScanDetails | undefined;
  saveExecutionParams: () => Promise<S3Link | undefined>
}

export default function AddExecution({ scan, saveExecutionParams }: AddExecutionProps): JSX.Element {
  const classes = useStyles();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const { createExecution, useScanPending } = useExecutions();
  if (!scan) {
    throw console.error('Execution parameters link is required.');
  }

  const isPending = useScanPending(scan.id);
  const addExecution = async () => {

      try {
          console.log('Adding execution', scan.id, isPending);
          if (isPending) {
              console.error('Scan is already pending.');
              setShowError(true);
              return;
          }

          const link = await saveExecutionParams();
          if (!link) {
            console.error('Failed to save execution parameters');
            return;
          }

          await createExecution({ scanId: scan.id, executionParamsLink: link });
          setShowSuccess(true);
      } catch (error) {
          console.error('Failed to create execution:', error);
      }
  };

  const navigate = useNavigate();
  return (
      <Box className={classes.root}>
          <Button className={`${classes.button} ${classes.saveButton}`} onClick={saveExecutionParams}>
              Save changes
          </Button>
          {!showSuccess ? (
              <Button className={`${classes.button} ${classes.addExecutionButton}`} onClick={addExecution}>
                  Append to execution list
              </Button>
          ) : (
              <div>
                <Button className={`${classes.button} ${classes.addExecutionButton}`} onClick={() => navigate('/manual-team-viewer/executions')}>
                    Go to execution list
                </Button>
                <Alert severity='success' className={classes.alertContainer}>
                    <AlertTitle>
                        <Typography variant='h6'>Scan submitted</Typography>
                    </AlertTitle>
                    <Typography variant='subtitle1'>
                        Scan was added to execution poll.
                    </Typography>
                </Alert>
              </div>
          )}
          {showError && (<Alert severity='error' className={classes.alertContainer}>
              <AlertTitle>
                  <Typography variant='h6'>Scan is already pending.</Typography>
              </AlertTitle>
              <Typography variant='subtitle1'>
                  Please wait for the current scan to finish before submitting another one.
              </Typography>
          </Alert>)}
      </Box>
  );
}
